import React from "react";
import moment from "moment-timezone";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  DialogTitle,
} from "@mui/material";

const ReleaseDetails = ({ note, open, close }) => {
  const formatDate = (d) => {
    const userTimezone = moment.tz.guess();
    return moment.tz(d, userTimezone).format("YYYY-MM-DD");
  };

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth="md">
      <DialogTitle>{note?.title}</DialogTitle>
      <DialogContent>
        <Typography variant="caption" color="text.secondary">
          Released: {formatDate(note?.createdAt)}
        </Typography>
        {note?.htmlBody && (
          <div
            dangerouslySetInnerHTML={{ __html: note.htmlBody }}
            style={{ paddingTop: 8 }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReleaseDetails;
